import React, { useEffect, useMemo, useState } from "react";
import { Form, Input } from "antd";
import { validateEmailAddress } from "@/utils/utils";

const EmailInput = ({
  formItemProps: _formItemProps,
  inputProps: _inputProps,
  required: _required,
  /**
   * Whether we should allow browser autofill (like chrome password manager) to automatically fill in the current user's saved email.
   */
  allowAutofill = true,
}) => {
  const [readOnly, setReadOnly] = useState(!allowAutofill);

  useEffect(() => {
    if (allowAutofill) return;

    const timeoutId = setTimeout(() => {
      setReadOnly(false);
    }, 1000);

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);

  const inputProps = useMemo(() => {
    return {
      maxLength: 320,
      ..._inputProps,
    };
  }, [_inputProps]);

  const formItemProps = useMemo(() => {
    const label = _formItemProps?.label || "Email";

    return {
      label,
      name: "email",
      rules: [
        {
          validator: (_, value) => {
            if (_required) {
              if (value && validateEmailAddress(value)) {
                return Promise.resolve();
              } else if (!value) {
                return Promise.reject(`Please enter ${label}`);
              }

              return Promise.reject("Please enter a valid email");
            }
            return Promise.resolve();
          },
        },
      ],
      ..._formItemProps,
    };
  }, [_formItemProps]);

  return (
    <>
      <Form.Item {...formItemProps}>
        <Input
          {...inputProps}
          /*
            Setting `readOnly` html attribute to `true` seems to prevent chrome autofill from immediately
            filling this input with a saved email.
           */
          readOnly={readOnly}
        />
      </Form.Item>
    </>
  );
};

export default EmailInput;
